import { DefaultLayoutState } from './contracts';
import { useAtom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

const siderCollapsedAtom = atomWithStorage('__is-sider-collapsed__', true);

export const useDefaultLayoutState = (): DefaultLayoutState => {
  const [isSiderCollapsed, toggleSider] = useAtom(siderCollapsedAtom);
  return {
    isSiderCollapsed,
    toggleSider,
  };
};
